import { formatTime } from "@src/appV2/redesign/utils/formatTime";
import { format, getYear, isBefore, startOfDay, subDays } from "date-fns";

import { type ChatChannel } from "../types";

export function getLastMessageDate(channel: ChatChannel) {
  const useTimestamp = channel.lastMessage ? channel.lastMessage.createdAt : channel.createdAt;
  const lastMessage = new Date(useTimestamp);
  const today = startOfDay(new Date());
  const yesterday = subDays(today, 1);

  if (isBefore(lastMessage, yesterday)) {
    const currentYear = getYear(today);
    const lastMessageYear = getYear(lastMessage);
    if (currentYear !== lastMessageYear) {
      return format(lastMessage, "MMM d, yyyy");
    }

    return format(lastMessage, "MMM d");
  }

  if (isBefore(lastMessage, today)) {
    return "Yesterday";
  }

  return formatTime(lastMessage);
}
